


















import { Component, Prop, Vue } from 'vue-property-decorator'
import { labelFor } from '@/models/sorewardsProgramTypes'

@Component({
  name: 'SorewardsProgramTypeDisplay'
})
export default class extends Vue {
  @Prop({ type: String, default: '' }) private programType!: string

  private get label() {
    return labelFor(
      this.programType,
      (key) => String(this.$t(key)),
      (key) => this.$te(key)
    )
  }

  private get secondaryCode() {
    if (!this.programType || this.label === this.programType) return ''
    return this.programType
  }
}
